import { createContext } from 'react';

const FieldArrayContext = createContext();

export default FieldArrayContext;
